import React, { useState } from 'react';
import RentalInputsContext from '@app/context/rental/RentalInputsContext';

const giftItems = [
  { id: 1, title: 'Flower Decoration', price: 2599 , imgSrc: "flower-decoration" },
  { id: 2, title: 'Gift Hamper', price: 999 , imgSrc: "gift-hamper" },
  { id: 3, title: 'Goodies Bag', price: 1199 , imgSrc: "goodies-bag" },
  { id: 4, title: 'Food Basket', price: 999 , imgSrc: "food-basket" },
  { id: 5, title: 'Fruit Basket', price: 779 , imgSrc: "fruit-basket" },
];

const GiftCard = ({ id, title, price, isSelected, onChange ,imgSrc}) => (
  <div
    className={`bg-white gift-card rounded-lg card-width shadow-sm p-2 mx-1 ${
      isSelected ? 'border border-warning' : 'border-transparent'
    }`}
  >
    <div className="d-flex justify-content-between">
      <img
        src={`https://cdn1.acedms.com//photos/images/obv-web/rental/${imgSrc}.png`}
        alt={title}
        className="gift-image"
      />
      <div className="form-check">
        <input
          type="checkbox"
          className="custom-checkbox"
          id={`gift-${id}`}
          checked={isSelected}
          onChange={() => onChange(id)}
        />
      </div>
    </div>
    <p className="mb-0 mt-2 small">{title}</p>
    <h6 className="mt-1 font-weight-bold">₹{price}</h6>
  </div>
);

const Gifts = () => {
  const [selectedGifts, setSelectedGifts] = useState([]);
  const { rentalInputs, setRentalInputs } = React.useContext(RentalInputsContext);

  const toggleGift = (id) => {
    const isAlreadySelected = selectedGifts.includes(id);
    const updatedSelectedGifts = isAlreadySelected
      ? selectedGifts.filter((giftId) => giftId !== id)
      : [...selectedGifts, id];
  
    setSelectedGifts(updatedSelectedGifts);
  
    // Get price of selected/unselected gift
    const gift = giftItems.find((item) => item.id === id);
    const priceChange = gift?.price || 0;
  
    // Adjust add_ons_charge
    const updatedCharge = isAlreadySelected
      ? (rentalInputs.add_ons_charge || 0) - priceChange
      : (rentalInputs.add_ons_charge || 0) + priceChange;
  
    setRentalInputs({
      ...rentalInputs,
      add_ons_charge: updatedCharge,
    });
    window.scrollTo({ top: 100, behavior: 'smooth' });
  };

  return (
    <>
    <h3 className="pb-3 charcol-grey">Customize your Rentals</h3>
    <div className="row">
      {giftItems.map((item) => (
       <div className="col-lg-2 col-md-6 col-6 mb-3" key={item.id}>
          <GiftCard
          key={item.id}
          id={item.id}
          title={item.title}
          price={item.price}
          imgSrc={item.imgSrc}
          isSelected={selectedGifts.includes(item.id)}
          onChange={toggleGift}
        />
       </div>
      ))}
    </div>
    </>
  );
};

export default Gifts;
